"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNextQueryString = void 0;
const lodash_1 = require("lodash");
const navigation_1 = require("next/navigation");
const qs_1 = require("qs");
const react_1 = require("react");
const utils_1 = require("./utils");
const DEBOUNCE_TIMER = 300;
const useNextQueryString = ({ parseOptions, stringifyOptions, } = {}) => {
    const searchParams = (0, navigation_1.useSearchParams)();
    const [localQuery, setLocalQuery] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        const params = Object.fromEntries(searchParams.entries());
        const parsed = (0, utils_1.parseSearchParams)((0, qs_1.stringify)(params), parseOptions);
        setLocalQuery(parsed);
    }, [parseOptions, searchParams]);
    const debouncedUpdateUrl = (0, react_1.useMemo)(() => (0, lodash_1.debounce)((newQuery) => {
        const queryString = (0, qs_1.stringify)(newQuery, stringifyOptions);
        const currentPath = window.location.pathname;
        const newUrl = queryString
            ? `${currentPath}?${queryString}`
            : currentPath;
        window.history.pushState(null, '', newUrl);
    }, DEBOUNCE_TIMER), [stringifyOptions]);
    (0, react_1.useEffect)(() => () => debouncedUpdateUrl.cancel(), [debouncedUpdateUrl]);
    const setQuery = (0, react_1.useCallback)((queryOrFunc) => {
        setLocalQuery((prev) => {
            const newQuery = typeof queryOrFunc === 'function' ? queryOrFunc(prev) : queryOrFunc;
            debouncedUpdateUrl(newQuery);
            return newQuery;
        });
    }, [debouncedUpdateUrl]);
    return [localQuery, setQuery];
};
exports.useNextQueryString = useNextQueryString;
//# sourceMappingURL=useNextQueryString.js.map